/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const AboutCansIconListSection = ({ title, description, media, cta }) => {
  return (
    <Box bg="backgroundLight" pt={[7, null, 9]} pb={[8, null, 10]}>
      <Container>
        <Grid columns={[null, 12, 1]} mb={[6, 7, 6, 7]}>
          <Box
            sx={{
              gridColumn: [null, '2 / 12', 'auto'],
              textAlign: 'center',
            }}
          >
            <Heading as="h2" variant="title2" mb={2}>
              {title}
            </Heading>
            <Box
              variant="text.body1"
              sx={{
                gridColumn: [null, '2 / 12', '1 / -1'],
                p: { m: 0 },
              }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
          </Box>
        </Grid>

        <Grid
          columns={[null, null, 3]}
          mb={[6, null, 8]}
          sx={{ alignItems: 'start', rowGap: 5 }}
        >
          {media.map(({ title, description }, index) => {
            return (
              <Grid
                columns={[null, 12, 1]}
                key={index}
                px={[0, null, null, 1]}
                sx={{ rowGap: '0' }}
              >
                <Box
                  mb={[2, 0, 2, 3]}
                  sx={{
                    gridColumn: [null, '1 / 5', 'auto'],
                    height: '112px',
                    textAlign: ['center'],
                  }}
                >
                  <img
                    src={`/images/icons/about-cans-${index + 1}.svg`}
                    alt=""
                    aria-hidden="true"
                  />
                </Box>
                <Box
                  sx={{
                    gridColumn: [null, '5 / 12', 'auto'],
                    textAlign: ['center', 'left', 'center'],
                  }}
                >
                  <Heading as="h3" variant="title4" mb={1}>
                    {title}
                  </Heading>
                  <Box
                    variant="text.body2"
                    dangerouslySetInnerHTML={{
                      __html: description.childMarkdownRemark.html,
                    }}
                    sx={{ p: { m: 0 } }}
                  />
                </Box>
              </Grid>
            )
          })}
        </Grid>

        {cta && (
          <Box
            sx={{
              textAlign: 'center',
              a: {
                display: 'inline-block',
                marginBottom: -3,
                minHeight: '50px',
              },
            }}
          >
            {cta}
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default AboutCansIconListSection
